/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EForeignStatus } from "../types/EForeignStatus.ts";

/**
 * @description 1 = Approved | 2 = PendingDocument | 3 = EquivalenceMade | 4 = Cancelled |
 */
export const eForeignStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Approved | 2 = PendingDocument | 3 = EquivalenceMade | 4 = Cancelled | ",
  ) as unknown as ToZod<EForeignStatus>;
